const priority = {
  High: 1,
  Balanced: 2,
  Scaled: 3,
};

export const sortByPriority = <T extends { similarity_level: string }>(items: T[]): T[] =>
  items.toSorted((a, b) => priority[a.similarity_level] - priority[b.similarity_level]);
